import { render } from "./presenters.vue?vue&type=template&id=23ca8851&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=23ca8851&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23ca8851"

export default script